import * as React from 'react';

function SvgCaretRightIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.702 7.529h0a.25.25 0 01.355 0l4.24 4.288h0l.005.006a.25.25 0 010 .355h0l-.002.002-4.24 4.24h0l-.003.002a.25.25 0 01-.355 0h0a.25.25 0 010-.353s0 0 0 0l3.538-3.539.527-.526-.523-.53-3.54-3.59-.002-.003a.25.25 0 010-.352z"
        fill="#000"
        stroke="#4C5980"
        strokeWidth={1.5}
      />
    </svg>
  );
}

export default SvgCaretRightIcon;
